import axios from 'axios';

import { getApi } from '../getApi/index';

function getDeviceType(): 'web' | 'mobile' | 'tablet' {
  const ua = navigator.userAgent;
  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
    return 'tablet';
  }
  if (
    /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
      ua,
    )
  ) {
    return 'mobile';
  }
  return 'web';
}

async function getUserIP(): Promise<string> {
  const { data } = await axios.get('https://api.ipify.org/?format=json');
  return data?.ip ?? '';
}

export async function logLoggin(
  UserId: number,
  UserName: string,
  SchoolId: string,
  SchoolName: string,
  ProfileId: string,
  ProfileName: string,
) {
  const api = getApi();
  const Ip = await getUserIP();
  const DeviceKind = getDeviceType();

  return api.post('auth/log', {
    UserId: String(UserId),
    UserName,
    SchoolId,
    SchoolName,
    ProfileId,
    ProfileName,
    Ip,
    DeviceKind,
    Origin: window.origin,
  });
}

export async function logRoute(
  UserId: number,
  UserName: string,
  SchoolId: string,
  SchoolName: string,
  ProfileId: string,
  ProfileName: string,
  RouteName: string,
) {
  const api = getApi();
  const Ip = await getUserIP();
  const DeviceKind = getDeviceType();

  return api.post('route/log', {
    UserId: String(UserId),
    UserName,
    SchoolId,
    SchoolName,
    ProfileId,
    ProfileName,
    Ip,
    DeviceKind,
    Origin: window.origin,
    EventType: `${RouteName} page`,
  });
}

export async function logEvent(
  EventType: string,
  UserId: number,
  ProfileId: string,
  SchoolId: string,
  ContentId: string,
  Personification: boolean,
  JsonTextWithAdditionalInformation: string,
) {
  const api = getApi();
  const DeviceKind = getDeviceType();

  return api.post('route/log', {
    EventType,
    UserId: String(UserId),
    ProfileId,
    SchoolId,
    ContentId,
    Personification,
    JsonTextWithAdditionalInformation,
    Origin: window.origin,
    DeviceKind,
  });
}
